import type { SpeechInputError } from "@productlane/ui"

/** What the reader has to do about a dictation that would not start. */
export function voiceErrorTitle(error: SpeechInputError): string {
	if (error === "denied") return "Microphone access is off for this site"
	if (error === "insecure-origin") return "Dictation needs https or localhost"
	return "Dictation stopped"
}

export function voiceErrorDescription(error: SpeechInputError): string {
	if (error === "denied") {
		return "Allow the microphone in your browser settings, then press the mic again."
	}
	if (error === "insecure-origin") {
		return "Your browser only hands out the microphone on a secure page. Open the app on localhost or over https."
	}
	return "Press the mic again to keep dictating."
}
